import { FC, useEffect, useMemo } from 'react';
import { useInView } from 'react-intersection-observer';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';

import { Log, useUBL } from '@common/log-manager';
import { Typography } from '@common/styles';

interface Props {
  item: {
    description: string;
    count: number;
  };
  color: string;
  index: number;
  onClick: (index: number) => void;
}

export const DescriptionChip: FC<React.PropsWithChildren<Props>> = ({ item, color, index, onClick }) => {
  const {
    query: { catalog_product_id },
  } = useRouter();
  const { ref: chip_ref, inView: in_view } = useInView({ threshold: 0.5 });
  const sendUBL = useUBL();

  const ubl: Omit<Log, 'category'> = useMemo(
    () => ({
      navigation: 'product_detail',
      object_section: 'beauty_ingridient',
      object_button: 'button',
      object_id: `${item.description.toLowerCase()} ${item.count}개`.replace(/\s/g, '_'),
      object_idx: index,
      data: {
        original_product_id: catalog_product_id ? String(catalog_product_id) : '',
      },
    }),
    [item.description, item.count, index, catalog_product_id],
  );

  useEffect(() => {
    if (in_view) {
      sendUBL({
        category: 'impression',
        ...ubl,
      });
    }
  }, [in_view, sendUBL, ubl]);

  const handleChipClick = () => {
    sendUBL({
      category: 'click',
      ...ubl,
    });
    onClick(index);
  };
  return (
    <SC.Chip ref={chip_ref} bg_color={color} onClick={handleChipClick}>
      <p className={Typography.BODY_13_MEDIUM}>
        {item.description} <span className='count'>{item.count}개</span>
      </p>
    </SC.Chip>
  );
};

const SC = {
  Chip: styled.li<{ bg_color: string }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 3px 5px;
    margin-right: 8px;
    border-radius: 2px;
    background-color: rgba(173, 181, 189, 0.1);

    .count {
      color: ${({ bg_color }) => bg_color};
    }
  `,
};
